import { ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table, useSimpleTableDataSource } from "capitalrx-components-2.0/lib/general";
import { formatDollars } from "capitalrx-utilities";

import { MedicarePrescriptionPaymentPlanEstimate } from "@/api/axios";

interface Props {
  results: ReadonlyArray<MedicarePrescriptionPaymentPlanEstimate>;
}

const PaymentsTable: React.FC<Props> = ({ results }: Props) => {
  const { t: translate } = useTranslation();
  const rows = useMemo(
    () =>
      results.map((payment, i) => ({
        id: i,
        data: payment.estimation,
      })),
    [results],
  );

  const dataSource = useSimpleTableDataSource(rows);
  return (
    <Table dataSource={dataSource} className="payments-table">
      <Table.Date name="month" title={translate("MEDICARE_PRESCRIPTION_PAYMENT_PLAN.paymentTable.month")} sortable format="MMMM" initialWidth="span" />
      <Table.Custom name="billed_amount" sortable title={translate("MEDICARE_PRESCRIPTION_PAYMENT_PLAN.paymentTable.estimadedBill")} align="right" initialWidth="span">
        {(value: unknown, _): ReactNode => {
          return formatDollars(value as string);
        }}
      </Table.Custom>
      <Table.Custom name="total_billed_amount" sortable title={translate("MEDICARE_PRESCRIPTION_PAYMENT_PLAN.paymentTable.amountBilled")} align="right" initialWidth="span">
        {(value: unknown, _): ReactNode => {
          return formatDollars(value as string);
        }}
      </Table.Custom>
      <Table.Custom name="true_out_of_pocket_amount" sortable title={translate("MEDICARE_PRESCRIPTION_PAYMENT_PLAN.paymentTable.outOfPocket")} align="right" initialWidth="span">
        {(value: unknown, _): ReactNode => {
          return formatDollars(value as string);
        }}
      </Table.Custom>
      <Table.Custom name="total_true_out_of_pocket_amount" sortable title={translate("MEDICARE_PRESCRIPTION_PAYMENT_PLAN.paymentTable.ytdOutOfPocket")} align="right" initialWidth="span">
        {(value: unknown, _): ReactNode => {
          return formatDollars(value as string);
        }}
      </Table.Custom>
    </Table>
  );
};

export default PaymentsTable;
